import { FileInfoStatus } from './FileInfoStatus'
import { FileInfoType } from './FileInfoType'
import { DocumentId } from './DocumentId'
import { FileName } from './FileName'
import { RejectionReason } from './RejectionReason'

export class FileInfo {
  private _documentId: DocumentId
  private _fileName: FileName
  private _rejectionReason: RejectionReason
  private _fileStatus: FileInfoStatus
  private _fileType: FileInfoType

  constructor (
    documentId: DocumentId,
    fileName: FileName,
    rejectionReason: RejectionReason,
    fileStatus: FileInfoStatus,
    fileType: FileInfoType
  ) {
    this._documentId = documentId
    this._fileName = fileName
    this._rejectionReason = rejectionReason
    this._fileStatus = fileStatus
    this._fileType = fileType
  }

  documentId (): number {
    return this._documentId.value()
  }

  fileName (): string {
    return this._fileName.value()
  }

  reasonRejection (): string {
    return this._rejectionReason.value()
  }

  fileStatus (): FileInfoStatus {
    return this._fileStatus
  }

  fileType (): FileInfoType {
    return this._fileType
  }
}
